import colors from 'vuetify/es5/util/colors'

export default {
  primary: '#EF454A',
  secondary: '#006E49',
  accent: colors.cyan.base,
  error: colors.pink.base,
  warning: colors.deepPurple.base,
  info: colors.lightBlue.base,
  success: colors.green.base
}
